// Core
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getPendingtAssessment_USER,
  getUserCertificationRequest_USER,
  getLatestAssessment_USER
} from "../../../../Redux/Slices/User/userSlice";

// Styles
import "./styles.scss";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// Svg icon
import { ReactComponent as SilverSVG } from '../../../../Assets/Svg/User/silver.svg';
import { ReactComponent as BronzeSVG } from '../../../../Assets/Svg/User/bronze.svg';
import { ReactComponent as GoldSVG } from '../../../../Assets/Svg/User/gold.svg';

// Custom components
import Assessment from "Components/ScheduledAssesment";
import Hero from "../../../../Assets/Images/dashboardHero.png";
import HeroSlider from "Components/HeroCarousel";
import ReportComponent from "Components/ReportComponent";
import Reports from "Components/Reports";
import moment from "moment";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import InstructionsModalForUser from "Components/InstructionsModal/InstructionsModalForUser";
import Button from "Components/Button";

const Dashboard = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showInstructions, setShowInstructions] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const isLoading = useSelector((state) => state.user.isLoading);
  
  
  const [submitName, setSubmitName] = useState("");
  const [certificateDetails, setCertificateDetails] = useState({});
  const [schuledAssessmentData, setSchuledAssessmentData] = useState([]);
  const [latestReport, setLatestReport] = useState(null);
  const [activeComponent, setActiveComponent] = useState(
    location.state?.activeComponent || "home"
  );

  useEffect(() => {
    getPreAssessmentUsers();
    getUserCertificate();
    getLatestReportDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPreAssessmentUsers = () => {
    dispatch(
      getPendingtAssessment_USER({
        callBack: getSchuledAssessmentUsers,
      })
    );
  };
  const getLatestReportDetails = () => {
    dispatch(
      getLatestAssessment_USER({
        callBack: (data) => {
          setLatestReport(data?.data); // Set the data in the component's state
        },
      })
    );
  };

  const getUserCertificate = () => {
    dispatch(
      getUserCertificationRequest_USER({
        callBack: getUserCertificationRequestCB_USER,
      })
    );
  };

  const getUserCertificationRequestCB_USER = (data) => {
    setCertificateDetails(data);
  };

  const getSchuledAssessmentUsers = (data) => {
    setSchuledAssessmentData(
      Array.isArray(data?.data?.datas) ? data.data.datas : []
    );
    setSubmitName(data?.data?.userName);
  };

  const handleViewPastReports = () => {
    setActiveComponent("pastReports");
  };

  const handleViewLatestReports = () => {
    setActiveComponent("latestReports");
  };

  const handleOnClick = (companyName, assessmentId, completionPercentage) => {
    setSelectedAssessment({
      companyName,
      assessmentId,
      completionPercentage,
    });
    setShowInstructions(true);
  };

  const handleContinue = () => {
    if (!selectedAssessment) return;
    setShowInstructions(false);
    navigate(`/pre-assessment/questions/${selectedAssessment.assessmentId}`, {
      state: {
        companyName: selectedAssessment.companyName,
        assessmentId: selectedAssessment.assessmentId,
        completionPercentage: selectedAssessment.completionPercentage,
      },
    });
  };


  return (
    <MainLayout>
      <InstructionsModalForUser
        isOpen={showInstructions}
        onClose={() => setShowInstructions(false)}
        onContinue={handleContinue}
        Button={Button}
      />
      {activeComponent === "home" && (
        <div className="dashboard-container">
          <div style={{ paddingBottom: "20px" }}>
            {/* Prevents components from overlapping */}
            <h1>Dashboard Overview</h1>

            <div style={certificateDetails.length === 0 ? { display: "none" } : {}}>
              <div className="hero-container position-relative">        
                {isLoading === "loading" ? (
                  <>
                    <Skeleton height={200} className="heroImg" />
                    <div className="certificateContent">
                      <Skeleton height={30} width={200} />
                      <Skeleton height={20} width={150} className="bronzeDate" />
                    </div>
                  </>
                ) : certificateDetails?.prize === "bronze" ? (
                  <>
                    <BronzeSVG className="heroImg"  alt="Bronze"/>
                    <div className="certificateContent">
                      <div className="bronzeText">
                        {certificateDetails?.company_name}
                      </div>
                      <div className="bronzeDate">
                        Assessment Date :{" "}
                        <span>
                          {moment(certificateDetails?.startDate)?.format(
                            "DD/MM/YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                  </>
                ) : certificateDetails?.prize === "gold" ? (
                  <>
                    <GoldSVG className="heroImg" alt="Gold"/>
                    <div className="certificateContent">
                      <div className="goldText">
                        {certificateDetails?.company_name}
                      </div>
                      <div className="goldDate">
                        Assessment Date :{" "}
                        <span>
                          {moment(certificateDetails?.startDate)?.format(
                            "DD/MM/YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                  </>
                ) : certificateDetails?.prize === "silver" ? (
                  <>
                    <SilverSVG className="heroImg" alt="Silver"/>
                    <div className="certificateContent">
                      <div className="silverText">
                        {certificateDetails?.company_name}
                      </div>
                      <div className="silverDate">
                        Assessment Date :{" "}
                        <span>
                          {moment(certificateDetails?.startDate)?.format(
                            "DD/MM/YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>

            <h3 className="pending-heading">Scheduled Assessments</h3>
            <div className="assessment-container-dashboard">
              {isLoading === "loading" ? (
                <Skeleton height={200} duration={1} />
              ) : (() => {
                const filteredAssessments = schuledAssessmentData.filter(
                  (assessment) =>
                    assessment.assessment_status === 1 || assessment.assessment_status === 2
                );

                if (filteredAssessments.length === 0) {
                  return (
                    <>
                      <h5 className="text-center">No Ongoing Assessment Available</h5>
                      <HeroSlider />
                    </>
                  );
                }

                return filteredAssessments.map((assessment, index) => (
                  <React.Fragment key={assessment.assignment_id}>
                    <Assessment
                      assessmentName={assessment.assessment_name}
                      referenceName={assessment.assessment_backlog.reference_name}
                      status={
                        assessment.assessment_status === 1 ? "Pending" : "In Progress"
                      }
                      plannedDate={new Date(assessment.startDate).toLocaleDateString("en-IN")}
                      dueDate={new Date(assessment.dueDate).toLocaleDateString("en-IN")}
                      assessorName={assessment.assessment_backlog.users.assessor_name}
                      completionPercentage={assessment.percentage}
                      handleOnclick={() =>
                        handleOnClick(
                          assessment.assessment_backlog.company_name,
                          assessment.backlog_id,
                          assessment.percentage
                        )
                      }
                      submittedName={submitName}
                    />
                    {index === 0 && <HeroSlider />}
                  </React.Fragment>
                ));
              })()}
            </div>



            {/* <HeroSlider /> */}
            <div className="reports-container-dashboard">
              {isLoading === "loading" ? (
                <>
                  <Skeleton height={200} duration={1} />
                </>
              ) : latestReport && latestReport.firstApproved?.assessment_backlog ? (
                <>
                  <h3 className="latest-heading">Latest Report</h3>
                  <ReportComponent
                    reportName={latestReport.firstApproved?.assessment_name}
                    referenceName={latestReport.firstApproved?.assessment_backlog?.reference_name}
                    accessorName={latestReport.firstApproved?.assessment_backlog?.users?.assessor_name}
                    sentOn={new Date(latestReport.firstApproved?.assessment_backlog?.approved_on).toLocaleDateString()}
                    handleviewpastreports={handleViewPastReports}
                    handleviewlatestreports={handleViewLatestReports}
                  />
                </>
              ) : (
                "" // Optionally display a loading message while the data is being fetched
              )}
            </div>
          </div>
        </div>
      )}
      {activeComponent === "latestReports" && (
        <Reports reportType="latest" setActiveComponent={setActiveComponent} />
      )}
      {activeComponent === "pastReports" && (
        <Reports reportType="past" setActiveComponent={setActiveComponent} />
      )}
    </MainLayout>
  );
};

export default Dashboard;
